import { BrowserLocaleDateFormatter, DUMB_COMPONENT_TYPES, FORM_ELEMENT_TYPES, getFlowElement, selectTypes } from '../';
import { EFFECTS } from '../types/Calls';
import { getConditionsValues } from './getConditionValues';
import { isCheckboxChecked } from './checkboxValue';
export const isEmail = (email) => {
    return RegExp(/^(([^\\<>()\[\]\.,;:\s@\"]+(\.[^\\<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^\\<>()[\]\.,;:\s@\"]+\.)+[^\\<>()[\]\.,;:\s@\"]{2,})$/i).test(email);
};
export const isValidURL = (url) => {
    const re = /^(?:http(s)?:\/\/)?[\w.-]+(?:\.[\w.-]+)+[\w\-._~:/?#[\]@!$&'()*+,;=.]+$/;
    return re.test(String(url).toLowerCase());
};
export const isValidPhoneNumber = (number) => {
    const re = /^(\+|00)[(]{0,1}[0-9]{1,4}[)]{0,1}[-\s./0-9]{6,14}$/;
    return re.test(number);
};
export const validateFlowElement = (call, element, stepId, resources, instanceLength = 0, groupInstance, elementValue, changesRequested = false, optionGroups) => {
    const { elementType, config, title, isEditable } = element;
    const value = elementValue ? elementValue : element.value;
    const condition = getConditionsValues(call, element, stepId, groupInstance);
    const { visible, valid, required, editable } = condition;
    const dumbComponents = [...DUMB_COMPONENT_TYPES, FORM_ELEMENT_TYPES.GROUP];
    let resource = undefined;
    if (changesRequested && !isEditable)
        return { error: false, errorMsg: '', condition, resource };
    if (!(visible && editable))
        return { error: false, errorMsg: '', condition, resource };
    if (elementType === FORM_ELEMENT_TYPES.GROUP) {
        const min = config?.min;
        const max = config?.max;
        if (min && (instanceLength < Number(min)))
            return {
                error: true,
                errorMsg: `A minimum of ${min} ${title}s is needed.`,
                condition,
                resource,
            };
        if (max && (instanceLength > Number(max)))
            return {
                error: true,
                errorMsg: `There can't be more than ${max} ${title}s.`,
                condition,
                resource,
            };
    }
    if (dumbComponents.includes(elementType))
        return {
            error: false,
            errorMsg: '',
            condition,
            resource,
        };
    const optionsGroupTag = element.optionsGroup?.tag;
    if (optionGroups?.length && optionsGroupTag && selectTypes.includes(elementType)) {
        const selected = (Array.isArray(value) ? value : [value]).filter((v) => v || v === 0).map(String);
        if (selected.length) {
            const group = optionGroups.find((g) => g.tag === optionsGroupTag);
            const validValues = new Set((group?.options || []).map((o) => o.value));
            const stale = selected.find((v) => !validValues.has(v));
            if (stale !== undefined)
                return {
                    error: true,
                    errorMsg: `The selected option "${stale}" is no longer available. Choose a valid option.`,
                    condition,
                    resource,
                };
        }
    }
    if (resources?.length && elementType === FORM_ELEMENT_TYPES.SELECT_PARTITION && (value || value === 0)) {
        const validPartitions = new Set(resources.filter((r) => !r.partition?.disabled).map((r) => String(r.partition.id)));
        if (!validPartitions.has(String(value)))
            return {
                error: true,
                errorMsg: 'The selected partition is no longer available. Choose a valid partition.',
                condition,
                resource,
            };
    }
    if (elementType === FORM_ELEMENT_TYPES.PARTITION_RESOURCES) {
        let partitionValue;
        if (groupInstance) {
            const childInstance = groupInstance
                .childInstances?.find((child) => child.elementType === FORM_ELEMENT_TYPES.SELECT_PARTITION);
            partitionValue = childInstance?.value;
        }
        else {
            const { form } = getFlowElement(call, element.id);
            const selectPartition = form?.flow.find((element) => element.elementType === FORM_ELEMENT_TYPES.SELECT_PARTITION);
            partitionValue = selectPartition?.value;
        }
        resource = resources?.find((resource) => resource.partition.id == partitionValue);
        if (!resource)
            return { error: false, errorMsg: '', condition };
        const { min, max, fixed } = resource;
        if (!fixed && (value && !!min && (min >= 0) && Number(value) < Number(min))) {
            return {
                error: true,
                errorMsg: `The value must be higher than ${min}`,
                condition,
                resource,
            };
        }
        if (!fixed && (value && !!max && (max >= 0) && Number(value) > Number(max))) {
            return {
                error: true,
                errorMsg: `The value must be lower than ${max}.`,
                condition,
                resource,
            };
        }
    }
    if (!valid)
        return {
            error: true,
            errorMsg: 'This value is not valid.',
            condition,
            resource,
        };
    const isEmptyValue = elementType === FORM_ELEMENT_TYPES.CHECKBOX ? !isCheckboxChecked(value) :
        Array.isArray(value) ? (!value.length || !value.join('')) : (!value && (value !== 0));
    if ((required || config?.required) && isEmptyValue)
        return {
            error: true,
            errorMsg: 'This is mandatory.',
            condition,
            resource,
        };
    const min = config?.min;
    const max = config?.max;
    if (elementType === FORM_ELEMENT_TYPES.TEXT_AREA) {
        if (min && value?.length < Number(min))
            return {
                error: true,
                errorMsg: `The text must have a minimum of ${min} characters.`,
                condition,
                resource,
            };
        if (max && value?.length > Number(max))
            return {
                error: true,
                errorMsg: `The text must have less than ${max} characters.`,
                condition,
                resource,
            };
    }
    if (elementType === FORM_ELEMENT_TYPES.DATE) {
        const dateValue = new Date(value || '').getTime();
        if (min) {
            const minDate = new Date(min).getTime();
            if (!!dateValue && dateValue < minDate)
                return {
                    error: true,
                    errorMsg: `The value must be after ${BrowserLocaleDateFormatter.format(new Date(min))}.`,
                    condition,
                    resource,
                };
        }
        if (max) {
            const maxDate = new Date(max).getTime();
            if (!!dateValue && dateValue > maxDate)
                return {
                    error: true,
                    errorMsg: `The value must be before ${BrowserLocaleDateFormatter.format(new Date(max))}.`,
                    condition,
                    resource,
                };
        }
    }
    else {
        if (((value || value === 0) && min && (min >= 0) && Number(value) < Number(min)) || (!value && (value !== 0) && min && (min >= 0)))
            return {
                error: true,
                errorMsg: `The value must be above ${min}.`,
                condition,
                resource,
            };
        if (((value || value === 0) && max && (max >= 0) && Number(value) > Number(max)) || (!value && (value !== 0) && max && (max >= 0)))
            return {
                error: true,
                errorMsg: `The value must be below ${max}.`,
                condition,
                resource,
            };
    }
    if (elementType === FORM_ELEMENT_TYPES.EMAIL && value && !isEmail(String(value)))
        return {
            error: true,
            errorMsg: 'Insert a valid email.',
            condition,
            resource,
        };
    if (elementType === FORM_ELEMENT_TYPES.PHONE_NUMBER && value &&
        !isValidPhoneNumber(String(value).replace(/[|]/g, ''))) {
        return {
            error: true,
            errorMsg: 'Insert a valid phone number.',
            condition,
            resource,
        };
    }
    return { error: false, errorMsg: '', condition, resource };
};
export const validateWizzardFlowElement = (elements, optionGroups, call) => {
    let errorMsg = 'Condition value is not possible';
    return elements.map((el) => {
        {
            if (el.effects && el.effects.length) {
                const allElementsValid = el.effects.every((effect) => {
                    if (effect.validation.elements?.length) {
                        const allElementsExist = effect.validation.elements.every((condEl) => {
                            const { element } = getFlowElement(call, condEl.id);
                            return !!element;
                        });
                        if (!allElementsExist) {
                            errorMsg = 'Some elements in the condition do not exist';
                            return false;
                        }
                    }
                    if (effect.effect === EFFECTS.SUM) {
                        return true;
                    }
                    if (effect.validation.elements?.length) {
                        return effect.validation.elements.every((condEl) => condEl.elementType && effect.validation.values?.length && selectTypes.includes(condEl.elementType) ?
                            optionGroups.find((opt) => opt.id == condEl.optionsGroupId)?.options.
                                find((option) => option.value == effect.validation.values[0]) : true);
                    }
                    return true;
                });
                if (!allElementsValid) {
                    return { ...el, error: true, errorMsg };
                }
            }
            return { ...el, error: false, errorMsg: '' };
        }
    });
};
